import axios from "axios";
import qs from "qs";

import {api} from "@/plugins/util";

export function getGuaranteeOrder(pageNum, pageSize) {
    return axios.get(api + "/companyRz/getGuaranteeOrder", {
        params: {
            pageNum,
            pageSize
        }
    })
}

export function findById(id) {
    return axios.post(api + "/finance/findById", id)
}
